export const MAX_PRODUCT_DESCRIPTION_LENGTH = 100;
